import {REPORT_TEAMS_FIBC} from '/enum/records.enum';

export default {
  reportName: REPORT_TEAMS_FIBC,
};
